"use strict";import{tag as t}from"../custom-tag.js";export function backward15Icon({height:a=16,width:l=16,hidden:r=!1,title:e="Backward 15"}={}){return t`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <mask
        id="backward-15_svg__mask0_6875_6793"
        width="20"
        height="17"
        x="2"
        y="4"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.61 4 3.653 6.863 8.61 9.726V7.36h8.182a4.215 4.215 0 0 1 0 8.43h-.528v.992h.528a5.207 5.207 0 1 0 0-10.414H8.611z"
          clip-rule="evenodd"
        />
        <path
          fill="currentColor"
          d="M4.75 19.84H3.712v-6.545L2 14.178v-1.08l1.724-.894h1.025zm2.897-1.854H8.76q.12.534.567.84.426.294 1.047.294.775 0 1.244-.534.415-.48.415-1.266 0-.883-.513-1.342-.425-.392-1.124-.392-.937 0-1.527.698h-.927l.163-4.08h4.691v.883H9.054l-.087 2.237q.698-.557 1.67-.557 1.134 0 1.821.742.655.71.655 1.855 0 1.19-.819 1.942-.752.698-1.93.698-1.19 0-1.975-.698a2.23 2.23 0 0 1-.742-1.32"
        />
      </mask>
      <g mask="url(#backward-15_svg__mask0_6875_6793)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=backward15.js.map
